import { render, staticRenderFns } from "./GroupedCoursesCard.vue?vue&type=template&id=1aa3d14a&scoped=true&"
import script from "./GroupedCoursesCard.vue?vue&type=script&lang=js&"
export * from "./GroupedCoursesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa3d14a",
  null
  
)

export default component.exports